exports = module.exports = require("../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-5916fb02]{background-color:#fbfbfb}.setting-body[data-v-5916fb02]{background-color:#fdfdfd}.gravatar-pic[data-v-5916fb02]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}.rg-pic-wrapper .rg-pic-uploader-wrapper[data-v-5916fb02]{display:none}.rg-pic-wrapper:hover .rg-pic-uploader-wrapper[data-v-5916fb02]{display:block}", ""]);

// exports
